




























































































































import axios from 'axios';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';

import { OrderItem } from '@/models/order/OrderItem';

@Component
export default class OrderList extends Vue {
    public orders: OrderItem[] = [];
    public filterByStatus: string = 'OPEN';
    public loading: boolean = true;

    get ordersByStatus () {
        return this.orders.filter((order: OrderItem) =>
            order.status === this.filterByStatus);
    }

    get openOrdersCount () {
        return this.orders.filter((order: OrderItem) =>
            order.status === 'OPEN').length;
    }

    get closedOrdersCount () {
        return this.orders.filter((order: OrderItem) =>
            order.status === 'CLOSED').length;
    }

    public formattedOrderDate (input: string) {
        moment.locale('sv_SE');
        const date = moment(input);
        return date.format("D MMMM YYYY");
    }

    public fetchOrders () {
        axios.get('/order')
            .then((response) => {
                this.orders = response.data;
                this.loading = false;
            })
            .catch((error) => {
                this.$store.dispatch('shared/error', error.response);
            });
    }

    public setStatus (status: string) {
        this.filterByStatus = status;
    }

    public created () {
        this.fetchOrders();
    }
}
